export var ACTION_ENCODING;
(function (ACTION_ENCODING) {
    ACTION_ENCODING[ACTION_ENCODING["DANGEROUS_GHOST"] = 0] = "DANGEROUS_GHOST";
    ACTION_ENCODING[ACTION_ENCODING["EDIBLE_GHOST"] = 1] = "EDIBLE_GHOST";
    ACTION_ENCODING[ACTION_ENCODING["PILL"] = 2] = "PILL";
    ACTION_ENCODING[ACTION_ENCODING["BISCUIT"] = 3] = "BISCUIT";
})(ACTION_ENCODING || (ACTION_ENCODING = {}));
